<template>
    <div class="bg-white
                    rounded-md
                    shadow print:shadow-none
                    p-6
                    mb-4 print:-my-8">
        <h3 class="text-lg
                       mb-4">
            Your Services
        </h3>

        <div class="grid
                        gap-2
                        mb-4
                        text-sm"
             :class="'tablet:grid-cols-' + serviceTypes.length">
            <div v-for="serviceType in serviceTypes"
                 :key="serviceType"
                 class="border
                        border-black
                        rounded-md
                        p-4">
                <h4 class="text-md
                               text-salmon">
                    {{ serviceType.length > 2? serviceType.charAt(0).toUpperCase() + serviceType.slice(1): serviceType.toUpperCase() }}
                </h4>
                <ul v-if="services.hasOwnProperty(serviceType) && services[serviceType].length"
                    class="list-disc list-outside ml-4">
                    <li v-for="service in services[serviceType]"
                        :key="service.name">
                        {{ service.name }}
                    </li>
                </ul>
                <ul v-if="addOns.hasOwnProperty(serviceType) && (addOns[serviceType].base !== {} || addOns[serviceType].equipment !== {})"
                    v-for="(items, index) in addOns[serviceType]"
                    :key="index"
                    class="list-disc list-outside ml-4">
                    <li v-for="item in items"
                        :key="item.name">
                        {{ nameFilter(item.name) }}
                        <span v-if="item.quantity > 1"
                              class="bg-salmon
                                         text-white
                                         text-center
                                         mx-1
                                         pl-1.5
                                         pr-1.5
                                         rounded-full
                                         font-normal">
                                {{ item.quantity }}
                            </span>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="hasPromotions">
            <h4 class="text-md">
                Promotions
            </h4>
            <p v-if="hasMultipleChoicePromo" class="text-sm">
                {{ getMultiplePromoText }}
            </p> 
            <p v-else class="text-sm">
                {{ getSinglePromoText }}
            </p>
        </div>


        <!-- <h4 v-if="isGwp"
            class="text-md">
            Free Gift With Your Order
        </h4>
        <p v-if="isGwp"
           class="text-sm"
           :class="{'mb-4' : hasHboMax || isFmf}"
        >
            A {{ gwpAmount }} Gift Card will be sent to you via email as thanks for choosing Breezeline.
        </p> -->

        <h4 v-if="isFmf"
            class="text-md">
            Enjoy your First Month of Internet Free
        </h4>
        <p v-if="isFmf && fmfAmount"
           class="text-sm"
           :class="{'mb-4' : hasHboMax}"
        >
            A ${{ fmfAmount }} credit has been applied to your first month as thanks for choosing Breezeline.
        </p>

        <h4 v-if="hasHboMax"
            class="text-md">
            HBO Max
        </h4>
        <p v-if="hasHboMax"
           class="text-sm">
            If your purchase included HBO Max, please follow this link to find out how to access the service:
            <a href="/hbomax"
               target="_blank"
               rel="noopener noreferrer">
                https://www.breezeline.com/hbomax
            </a>
        </p>

    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: "ServicesInfo",
    props: {
        services: {
            type: Object,
            default: () => ({})
        },
        addOns: {
            type: Object,
            default: () => ({})
        },
        serviceTypes: {
            type: Array,
            required: true
        },
        isGwp: {
            type: Boolean,
            required: false
        },
        gwpAmount: {
            type: String,
            required: false
        },
        isFmf: {
            type: Boolean,
            required: true
        },
        fmfAmount: {
            type: Number,
            required: true
        },
        hasHboMax: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        nameFilter(name) {
            return {
                'SIK - Tech Deliver': 'Self Installation Kit',
                'SIK - Ship Direct': 'Self Installation Kit',
                'WYW OpenSync - WiFi 6 Extender' : 'WiFi Your Way&trade; Home',
                'WiFi Your Way - WiFi 6 Router' : 'WiFi Your Way&trade; Home',
                'WiFi Your Way - WiFi 6 Router & WiFi 6 Extender' : 'WiFi Your Way&trade; Home',
                'Gateway Lease': this.isFiber ? 'High-Speed Fiber Modem Lease' : 'High-Speed Modem Lease',
                "Add'l WiFi 6 Extender": "Add'l WiFi Extender",
				"Unlimited Voice Service":"Unlimited Home Phone Service",
            }[name] || name
        },
    },
    computed: { 
        ...mapGetters({
            hasMultipleChoicePromo: 'Promotions/hasMultipleChoicePromo'
        }),
        ...mapState({
            appliedPromotions: state => state.Promotions.appliedPromotions,
            selectedGiftOption: state => state.Promotions.selectedGiftOption,
        }),
        hasPromotions() {
            return this.appliedPromotions && 
                typeof this.appliedPromotions === 'object' && 
                Object.keys(this.appliedPromotions).length > 0;
        },
        activePromotion() {
            const promoKey = Object.keys(this.appliedPromotions)[0];
            return promoKey ? this.appliedPromotions[promoKey] : null;
        },
        selectedGiftDetails() {
            if (!this.activePromotion || !this.activePromotion.giftOptions || !this.selectedGiftOption) {
            return null;
            }
            
            return this.activePromotion.giftOptions.find(option => 
            option.key === this.selectedGiftOption
            );
        },
            
        // Get the footnote for the selected gift option
        getMultiplePromoText() {
            if (!this.selectedGiftDetails) {
                return "Your promotion will be applied to your account.";
            }

            return this.selectedGiftDetails.cart_footNote || "Your promotion will be applied to your account.";
        },
        // Get the footnote for regular promotions
        getSinglePromoText() {
            if (!this.activePromotion || !this.activePromotion.product) {
                return "Your promotion will be applied to your account.";
            }

            const footNote = this.activePromotion.product.ui_elements.find(
            element => element.key === 'cart_footNote'
            );
            
            return footNote ? footNote.text : "Your promotion will be applied to your account.";
        }
    }
}
</script>

<style scoped>

</style>
